export default __webpack_public_path__ + "static/pressIIIT-53e59793f4b1169d8c71572b432648f5.png";